import { createContext, useContext } from "react";

/**
 * Indica que um layout persistente (ex.: ProfileShell) já renderiza a
 * BottomNav. Páginas que renderizam `<BottomNav />` internamente detectam
 * esse contexto e não duplicam a barra.
 */
export const ShellNavContext = createContext(false);

export const useShellNav = () => useContext(ShellNavContext);
